import { useContext } from 'react'

import { MODALS_ID } from '../../../constants'

import { ModalContext } from '../../../provider/ModalProvider'

import { ColumnItem } from '../../../components/common'
import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

export function SuccessInvestSuitabilityTestModal({ onDismiss }: { onDismiss: () => void }) {
  const { closeModal } = useContext(ModalContext)

  const dismiss = async () => {
    closeModal(MODALS_ID.ALERT)
    onDismiss()
  }

  return (
    <Modal id={MODALS_ID.ALERT} onClose={dismiss}>
      <ColumnItem $gap={16}>
        <Text size={18} weight={600} block={true} $textAlign="center">
          테스트 완료
        </Text>
        <Text size={14} weight={500} lineHeight={20} color="text_secondary" block={true} $textAlign="center">
          투자 적합성 테스트를 통과하셨어요
        </Text>
      </ColumnItem>
      <Modal.Footer>
        <Button type="primary" block={true} onClick={dismiss}>
          확인
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
